import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import NewsList from "@/pages/home/components/NewsList";
import HotMovies from "@/pages/home/components/HotMovies";
import SpecialPreview from "@/pages/home/components/SpecialPreview";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "黄色大片-最新热门电影资讯与推荐",
    description:
      "黄色大片网站提供最新最全的电影大片资讯，涵盖各类热门电影介绍和影评，帮助用户快速了解和选择合适影片观看。",
    keywords: "黄色大片,电影大片,热门电影,电影资讯,电影推荐,影视资源",
  });

  return (
    <>
      <HeroCarousel />
      <CategoryGrid />
      <NewsList />
      <HotMovies />
      <SpecialPreview />
      <SiteIntro />
    </>
  );
}